
import Clarity from '@microsoft/clarity';
import { useState } from "react";
import { Helmet } from "react-helmet";
import { useParams } from "react-router-dom";
import { CLARITY_PROJECT_ID } from '../../../project_config';
import Breadcrumb from "../../common/breadcrumb/Breadcrumb";
import Footer from "../../common/footer/Footer";
import Header from "../../common/header/Header";
import VisitSection from "./visit/VisitSection";

export default function VisitDoctorReserve() {
	Clarity.init(CLARITY_PROJECT_ID);
	const [isDesktop, setIsDesktop] = useState(window.innerWidth > 768);
	const params = useParams();
	const doctorId = params.doctorId;
	const linkDataList = [
		{ label: 'خانه', href: '/' },
		{ label: 'نوبت‌های درمانگر', href: '/visit_doctor_reserve/' + doctorId + '/' },
	];

	return (
		<>
			<Helmet>
				<title>رزرو نوبت درمانگر | همراهتیم</title>
				<meta name="description" content="رزرو نوبت درمانگر همراهتیم" />
			</Helmet>

			<div className="bg-[#F0F6FC] min-h-screen flex flex-col justify-between">
				<div>
					<Header isDesktop={isDesktop} />
					<div className="bg-white">
						<div className={`${isDesktop ? 'w-[1200px]' : ''} mx-auto`}>
							<Breadcrumb linkDataList={linkDataList} />
						</div>
					</div>
					<div className="spacer p-[50px]"></div>
					<div className={`${isDesktop ? 'w-[1200px]' : 'p-[10px]'} mx-auto`}>
						<VisitSection isDesktop={isDesktop} doctorId={doctorId} />
					</div>
				</div>
				<div className="spacer p-[50px]"></div>
				<div>
					<Footer isDesktop={isDesktop} />
				</div>
			</div>
		</>
	)
}
